import { useRef, useCallback } from 'react';

export const useAbortController = () => {
  const controllerRef = useRef<AbortController>(new AbortController());

  const abort = useCallback(() => {
    controllerRef.current.abort();
    controllerRef.current = new AbortController();
  }, []);

  return {
    signal: controllerRef.current.signal,
    abort,
  };
};
